import { Component } from 'react';
import { connect } from 'react-redux';

import { RootState, ToolTipType } from 'types';
import { checkDifferent, clone } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface SweptPathToolTipProps {
    toolTip: ToolTipType;
}

interface SweptPathToolTipState {
    toolTip: ToolTipType | null;
}

class ToolTip extends Component<SweptPathToolTipProps, SweptPathToolTipState> {
    constructor(props: SweptPathToolTipProps) {
        super(props);
        this.state = {
            toolTip: clone(props.toolTip),
        };
    }

    static getDerivedStateFromProps(props: SweptPathToolTipProps, state: SweptPathToolTipState) {
        if (checkDifferent(props.toolTip, state.toolTip)) {
            return { toolTip: clone(props.toolTip) };
        }

        return null;
    }

    render() {
        return (
            <div className="flex flex-col gap-y-1 p-3">
                {Array.from(
                    this.state.toolTip?.data
                        .reduce((map, obj) => {
                            const key = `${obj.name}-${obj.layer}`;
                            if (!map.has(key)) {
                                map.set(key, obj);
                            }
                            return map;
                        }, new Map())
                        .values()
                ).map((x: any, i) => {
                    return (
                        <div className="rounded-md" key={i}>
                            <div className="flex items-center gap-2">
                                <div className="font-bold">{translate(x.layer)} :</div>
                                <div>{x.name}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

const consolsStateToProps = (state: RootState) => ({
    map: state.map.map,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const consolsDispatchToProps = () => ({});

export default connect(consolsStateToProps, consolsDispatchToProps)(ToolTip);
